module.exports = __webpack_public_path__ + "static/media/zoudanyi.e3f2eaa3.png";